import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNoLeadingSpaces]'
})
export class NoLeadingSpacesDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    if (inputValue.length > 0 && inputValue[0] === ' ') {
      inputElement.value = inputValue.trim();
    }
  }
}
